import { render } from "./Igm.vue?vue&type=template&id=4b1bac9b"
import script from "./Igm.vue?vue&type=script&lang=js"
export * from "./Igm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Igm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b1bac9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b1bac9b', __exports__)) {
    api.reload('4b1bac9b', __exports__)
  }
  
  module.hot.accept("./Igm.vue?vue&type=template&id=4b1bac9b", () => {
    api.rerender('4b1bac9b', render)
  })

}


export default __exports__